export const getters = {
  agregateurs (state) {
    return state.agregateurs
  },
  agregateur (state) {
    return state.agregateur
  },  
  pagination(state){
    return state.pagination
  }
}
